// eslint-disable-next-line no-unused-vars
const localFormattedDateTime = (currency = 'en-IN', date?: string | Date) => {
    const dateObj = date ? new Date(date) : new Date()

    // Extract date components
    const day = String(dateObj.getDate()).padStart(2, '0')
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    const month = monthNames[dateObj.getMonth()]
    const year = dateObj.getFullYear()

    // Extract time components
    let hours = dateObj.getHours()
    const minutes = String(dateObj.getMinutes()).padStart(2, '0')
    const ampm = hours >= 12 ? 'PM' : 'AM'

    // Convert to 12-hour format
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'

    // Format as "DD-MMM-YYYY HH:MM AM/PM"
    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`
}

export { localFormattedDateTime }
